var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.35 5.85h-5.2V.65a.65.65 0 10-1.3 0v5.2H.65a.65.65 0 100 1.3h5.2v5.2a.65.65 0 101.3 0v-5.2h5.2a.65.65 0 100-1.3z",
    fill: "#1AB2C5"
  })));
}

export default SvgPlus;